import { ApiRequest, ApiResponse, fetchDataFromAPITyped } from './api-requests';
import type {
    PricingCode,
    CreatePricingCodePayload,
    UpdatePricingCodePayload,
    RedeemedCodesResponse,
    RedeemCodeResponse,
    PricingCodeRedeemer,
} from '../models/pricing-code-model';

// ── Host management endpoints ──

export const getPricingCodes = async (): Promise<ApiResponse<{ codes: PricingCode[] } | null>> => {
    const apiQuery: ApiRequest = {
        route: 'pricing-codes',
        request: { method: 'GET', entity: 'pricing_code', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const getPricingCodeDetail = async (codeId: string): Promise<ApiResponse<PricingCode | null>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-codes/${codeId}`,
        request: { method: 'GET', entity: 'pricing_code', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const createPricingCode = async (payload: CreatePricingCodePayload): Promise<ApiResponse<PricingCode | null>> => {
    const apiQuery: ApiRequest = {
        route: 'pricing-codes',
        request: { method: 'POST', entity: 'pricing_code', body: payload },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const updatePricingCode = async (codeId: string, payload: UpdatePricingCodePayload): Promise<ApiResponse<PricingCode | null>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-codes/${codeId}`,
        request: { method: 'PUT', entity: 'pricing_code', body: payload },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const revokePricingCode = async (codeId: string): Promise<ApiResponse<any>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-codes/${codeId}/revoke`,
        request: { method: 'POST', entity: 'pricing_code', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const restorePricingCode = async (codeId: string): Promise<ApiResponse<any>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-codes/${codeId}/restore`,
        request: { method: 'POST', entity: 'pricing_code', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const revokeCodeRedeemer = async (codeId: string, userId: string): Promise<ApiResponse<any>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-codes/${codeId}/redeemers/${userId}/revoke`,
        request: { method: 'POST', entity: 'pricing_code_redeemer', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const restoreCodeRedeemer = async (codeId: string, userId: string): Promise<ApiResponse<any>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-codes/${codeId}/redeemers/${userId}/restore`,
        request: { method: 'POST', entity: 'pricing_code_redeemer', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const searchCodeRedeemers = async (codeId: string, query: string): Promise<ApiResponse<{ results: PricingCodeRedeemer[] } | null>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-codes/${codeId}/redeemers/search`,
        request: {
            method: 'GET',
            entity: 'pricing_code_redeemer',
            body: undefined,
            searchParams: new URLSearchParams({ q: query }),
        },
    };
    return fetchDataFromAPITyped(apiQuery);
};

// ── Driver endpoints ──

export const redeemPricingCode = async (code: string, chargerId?: string): Promise<ApiResponse<RedeemCodeResponse | null>> => {
    const apiQuery: ApiRequest = {
        route: 'pricing-codes/redeem',
        request: {
            method: 'POST',
            entity: 'pricing_code',
            body: { code, charger_id: chargerId },
        },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const getMyRedeemedCodes = async (): Promise<ApiResponse<RedeemedCodesResponse | null>> => {
    const apiQuery: ApiRequest = {
        route: 'pricing-codes/my-codes',
        request: { method: 'GET', entity: 'pricing_code', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};
